import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'
import type { IResolvedParticipant } from '../../../Model/Project/IResolvedParticipant.js'

export const GetParticipantsEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.getParticipantsRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      return ProjectRepository.getParticipants(action.payload.projectId).pipe(
        mergeMap((response: IResolvedParticipant[]) =>
          of(
            project.getParticipantsRequestSuccess({
              projectId: action.payload.projectId,
              participants: response
            })
          )
        ),
        catchError((error) => of(project.getParticipantsRequestFailure({ error })))
      )
    })
  )
